export default __webpack_public_path__ + "static/media/cancel.f2ffd9d2.png";